import { SafeImg, ScrollReveal } from './ScrollReveal';

const featuredItems = [
  {
    tag: '韩漫精选',
    title: '《女神降临》完结纪念特辑',
    desc: '从平凡女孩到校园女神，看化妆改变命运的爆笑恋爱喜剧。经典韩漫完整版全集，下拉式一口气刷完！',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20woman%20transformation%20story%2C%20soft%20romantic%20atmosphere%20with%20warm%20pink%20and%20peach%20tones%2C%20fashion%20and%20makeup%20theme%2C%20clean%20minimalist%20background%20with%20subtle%20flower%20petals%2C%20editorial%20quality%2C%20no%20text&width=800&height=500&seq=carousel-01&orientation=landscape',
    stat1: '完结',
    stat2: '校园恋爱',
    stat3: '9.6分',
  },
  {
    tag: '日漫经典',
    title: '《咒术回战》热血连载追踪',
    desc: '咒术师与诅咒的激烈对决，每一话都燃到极致！紧跟日漫连载节奏，下拉式阅读体验无缝衔接最新话。',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Japanese%20manga%20style%20action%20scene%20with%20supernatural%20energy%20effects%2C%20dark%20dramatic%20lighting%20with%20warm%20orange%20accents%2C%20fighter%20silhouette%20with%20glowing%20energy%2C%20intense%20atmosphere%2C%20editorial%20quality%2C%20no%20text&width=800&height=500&seq=carousel-02&orientation=landscape',
    stat1: '连载中',
    stat2: '热血战斗',
    stat3: '9.8分',
  },
  {
    tag: '国漫崛起',
    title: '《狐妖小红娘》古风奇幻盛宴',
    desc: '前世今生的羁绊，人与妖的深情契约。国漫巅峰之作，完整版全集下拉式畅读，每一页都是壁纸级画风。',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20style%20fantasy%20scene%20with%20traditional%20elements%2C%20elegant%20flowing%20silk%20robes%20in%20warm%20red%20and%20gold%20tones%2C%20cherry%20blossom%20petals%2C%20ancient%20Chinese%20architecture%20background%2C%20soft%20dreamy%20atmosphere%2C%20editorial%20quality%2C%20no%20text&width=800&height=500&seq=carousel-03&orientation=landscape',
    stat1: '已完结',
    stat2: '古风奇幻',
    stat3: '9.7分',
  },
  {
    tag: '编辑力荐',
    title: '《我独自升级》暗黑奇幻巅峰',
    desc: '从最弱猎人成长为最强之王，系统流韩漫天花板。热血升级剧情全程高能，下拉式阅读带你沉浸式体验。',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20style%20scene%20with%20mysterious%20dungeon%20atmosphere%2C%20shadow%20warrior%20silhouette%20with%20glowing%20purple%20energy%2C%20dramatic%20lighting%20with%20dark%20and%20warm%20contrast%2C%20epic%20scale%20composition%2C%20editorial%20quality%2C%20no%20text&width=800&height=500&seq=carousel-04&orientation=landscape',
    stat1: '连载中',
    stat2: '暗黑奇幻',
    stat3: '9.9分',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            本周焦点
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精选专题推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-md mx-auto">
            编辑团队每周精选优质漫画，带你发现不容错过的好作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {featuredItems.map((item, i) => (
            <ScrollReveal key={i} delay={i * 100}>
              <a
                href="#carousel"
                className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-56 md:h-64 overflow-hidden">
                  <SafeImg
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-2 py-1 text-xs font-semibold rounded bg-primary-500/90 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                    {item.desc}
                  </p>
                  <div className="flex items-center gap-3">
                    <span className="text-xs px-2 py-1 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                      {item.stat1}
                    </span>
                    <span className="text-xs px-2 py-1 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                      {item.stat2}
                    </span>
                    <span className="text-xs font-bold text-accent-600 ml-auto whitespace-nowrap">
                      {item.stat3}
                    </span>
                  </div>
                </div>
              </a>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}